{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          98.039216
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          96.078431
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          100
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          100
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          96.078431
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          15.151515,
          6.470588
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          201.818182,
          7.006369,
          30.784314
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          100
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.2,
          100,
          19.607843
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          195,
          6.060606,
          87.058824
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          92.156863
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          217.2,
          100,
          19.607843
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          222.545455,
          100,
          10.784314
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196,
          100,
          97.058824
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          110,
          50,
          95.294118
        ],
        "alpha": 1,
        "hex": "#eff9ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          121.333333,
          100,
          17.647059
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          115.081967,
          35.260116,
          66.078431
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          123.043478,
          100,
          27.058824
        ],
        "alpha": 1,
        "hex": "#008a07"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          20,
          100,
          96.470588
        ],
        "alpha": 1,
        "hex": "#fff3ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.849624,
          95.683453,
          27.254902
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18,
          74.626866,
          73.72549
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          23.880597,
          100,
          39.411765
        ],
        "alpha": 1,
        "hex": "#c95000"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          3.75,
          100,
          96.862745
        ],
        "alpha": 1,
        "hex": "#fff0ef"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.288136,
          90.769231,
          25.490196
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          358.636364,
          67.692308,
          74.509804
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          346.626506,
          82.178218,
          39.607843
        ],
        "alpha": 1,
        "hex": "#b81237"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.571429,
          46.666667,
          94.117647
        ],
        "alpha": 1,
        "hex": "#e9eef7"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.74026,
          60.629921,
          24.901961
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.181818,
          35.106383,
          63.137255
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.813084,
          53.768844,
          39.019608
        ],
        "alpha": 1,
        "hex": "#2e5299"
      }
    }
  }
}
